/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface RiskDimensionLabel
 */
export interface RiskDimensionLabel {
  /**
   *
   * @type {number}
   * @memberof RiskDimensionLabel
   */
  readonly id: number;
  /**
   *
   * @type {string}
   * @memberof RiskDimensionLabel
   */
  name: string;
  /**
   *
   * @type {number}
   * @memberof RiskDimensionLabel
   */
  threshold: number;
}

/**
 * Check if a given object implements the RiskDimensionLabel interface.
 */
export function instanceOfRiskDimensionLabel(value: object): value is RiskDimensionLabel {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('name' in value) || value['name'] === undefined) return false;
  if (!('threshold' in value) || value['threshold'] === undefined) return false;
  return true;
}

export function RiskDimensionLabelFromJSON(json: any): RiskDimensionLabel {
  return RiskDimensionLabelFromJSONTyped(json, false);
}

export function RiskDimensionLabelFromJSONTyped(json: any, ignoreDiscriminator: boolean): RiskDimensionLabel {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    name: json['name'],
    threshold: json['threshold'],
  };
}

export function RiskDimensionLabelToJSON(value?: Omit<RiskDimensionLabel, 'id'> | null): any {
  if (value == null) {
    return value;
  }
  return {
    name: value['name'],
    threshold: value['threshold'],
  };
}
